import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "admin-contents-filters" }
const _hoisted_2 = { class: "filter-group" }
const _hoisted_3 = { class: "filter-label" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "filter-group" }
const _hoisted_6 = { class: "filter-label" }
const _hoisted_7 = { value: "" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "filter-group" }
const _hoisted_10 = { class: "filter-label" }
const _hoisted_11 = { value: "" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "filter-group" }
const _hoisted_14 = { class: "filter-label" }
const _hoisted_15 = { value: "" }
const _hoisted_16 = { value: "de" }
const _hoisted_17 = { value: "en" }
const _hoisted_18 = { class: "filter-group" }
const _hoisted_19 = { class: "filter-label" }
const _hoisted_20 = { value: "" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "filter-group" }
const _hoisted_23 = {
  type: "submit",
  class: "btn btn-primary btn-sm"
}
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "advanced-filter-row" }
const _hoisted_26 = { class: "filter-group" }
const _hoisted_27 = { class: "range-inputs" }
const _hoisted_28 = { class: "filter-group" }
const _hoisted_29 = { class: "range-inputs" }
const _hoisted_30 = { class: "filter-group" }
const _hoisted_31 = { class: "range-inputs" }
const _hoisted_32 = { class: "advanced-filter-row" }
const _hoisted_33 = { class: "filter-group" }
const _hoisted_34 = { class: "filter-group" }
const _hoisted_35 = { class: "filter-group" }
const _hoisted_36 = { class: "filter-group" }
const _hoisted_37 = {
  key: 0,
  class: "saved-searches"
}
const _hoisted_38 = { class: "saved-label" }
const _hoisted_39 = ["href"]
const _hoisted_40 = {
  key: 1,
  class: "save-search-form"
}
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = {
  type: "submit",
  class: "btn btn-sm btn-secondary"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[32] || (_cache[32] = _withModifiers((...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString($setup.label("search", "Search")) + ":", 1 /* TEXT */),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.filters.q) = $event)),
          type: "text",
          class: "filter-input",
          placeholder: $setup.label('searchPlaceholder', 'Search contents...'),
          onInput: _cache[1] || (_cache[1] = (...args) => ($setup.debouncedSearch && $setup.debouncedSearch(...args)))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4), [
          [_vModelText, $setup.filters.q]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString($setup.label("type", "Type")) + ":", 1 /* TEXT */),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.filters.type) = $event)),
          class: "filter-select",
          onChange: _cache[3] || (_cache[3] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
        }, [
          _createElementVNode("option", _hoisted_7, _toDisplayString($setup.label("allTypes", "All Types")), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.contentTypes, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option.value,
              value: option.value
            }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_8))
          }), 128 /* KEYED_FRAGMENT */))
        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelSelect, $setup.filters.type]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString($setup.label("status", "Status")) + ":", 1 /* TEXT */),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.filters.status) = $event)),
          class: "filter-select",
          onChange: _cache[5] || (_cache[5] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
        }, [
          _createElementVNode("option", _hoisted_11, _toDisplayString($setup.label("allStatuses", "All Statuses")), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.statusOptions, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option.value,
              value: option.value
            }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_12))
          }), 128 /* KEYED_FRAGMENT */))
        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelSelect, $setup.filters.status]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, _toDisplayString($setup.label("language", "Language")) + ":", 1 /* TEXT */),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.filters.language) = $event)),
          class: "filter-select",
          onChange: _cache[7] || (_cache[7] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
        }, [
          _createElementVNode("option", _hoisted_15, _toDisplayString($setup.label("allLanguages", "All Languages")), 1 /* TEXT */),
          _createElementVNode("option", _hoisted_16, _toDisplayString($setup.label("german", "German (DE)")), 1 /* TEXT */),
          _createElementVNode("option", _hoisted_17, _toDisplayString($setup.label("english", "English (EN)")), 1 /* TEXT */)
        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelSelect, $setup.filters.language]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, _toDisplayString($setup.label("book", "Book")) + ":", 1 /* TEXT */),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.filters.book_id) = $event)),
          class: "filter-select",
          onChange: _cache[9] || (_cache[9] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
        }, [
          _createElementVNode("option", _hoisted_20, _toDisplayString($setup.label("allBooks", "All Books")), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.books, (book) => {
            return (_openBlock(), _createElementBlock("option", {
              key: book.value,
              value: book.value
            }, _toDisplayString(book.label), 9 /* TEXT, PROPS */, _hoisted_21))
          }), 128 /* KEYED_FRAGMENT */))
        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelSelect, $setup.filters.book_id]
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("button", _hoisted_23, _toDisplayString($setup.label("filter", "Filter")), 1 /* TEXT */),
        ($setup.showClear)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: $props.clearUrl,
              class: "btn btn-secondary btn-sm",
              onClick: _cache[10] || (_cache[10] = (...args) => ($setup.clearFilters && $setup.clearFilters(...args)))
            }, _toDisplayString($setup.label("clear", "Clear")), 9 /* TEXT, PROPS */, _hoisted_24))
          : _createCommentVNode("v-if", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-secondary",
          onClick: _cache[11] || (_cache[11] = (...args) => ($setup.toggleAdvanced && $setup.toggleAdvanced(...args)))
        }, _toDisplayString($setup.advancedToggleLabel), 1 /* TEXT */)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["advanced-filters", { expanded: $setup.advancedOpen }])
      }, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "filter-label" }, "AP Value:", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.filters.ap_min) = $event)),
                type: "number",
                class: "filter-input small",
                min: "0",
                placeholder: "Min",
                onChange: _cache[13] || (_cache[13] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, $setup.filters.ap_min]
              ]),
              _cache[35] || (_cache[35] = _createElementVNode("span", null, "–", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.filters.ap_max) = $event)),
                type: "number",
                class: "filter-input small",
                min: "0",
                placeholder: "Max",
                onChange: _cache[15] || (_cache[15] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, $setup.filters.ap_max]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "filter-label" }, "AsP Cost:", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.filters.asp_min) = $event)),
                type: "number",
                class: "filter-input small",
                min: "0",
                placeholder: "Min",
                onChange: _cache[17] || (_cache[17] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, $setup.filters.asp_min]
              ]),
              _cache[37] || (_cache[37] = _createElementVNode("span", null, "–", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($setup.filters.asp_max) = $event)),
                type: "number",
                class: "filter-input small",
                min: "0",
                placeholder: "Max",
                onChange: _cache[19] || (_cache[19] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, $setup.filters.asp_max]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[40] || (_cache[40] = _createElementVNode("span", { class: "filter-label" }, "KaP Cost:", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($setup.filters.kap_min) = $event)),
                type: "number",
                class: "filter-input small",
                min: "0",
                placeholder: "Min",
                onChange: _cache[21] || (_cache[21] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, $setup.filters.kap_min]
              ]),
              _cache[39] || (_cache[39] = _createElementVNode("span", null, "–", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => (($setup.filters.kap_max) = $event)),
                type: "number",
                class: "filter-input small",
                min: "0",
                placeholder: "Max",
                onChange: _cache[23] || (_cache[23] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, $setup.filters.kap_max]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "filter-label" }, "Feature:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => (($setup.filters.feature) = $event)),
              type: "text",
              class: "filter-input",
              placeholder: "e.g., Antimagie",
              onChange: _cache[25] || (_cache[25] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
              [_vModelText, $setup.filters.feature]
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[42] || (_cache[42] = _createElementVNode("span", { class: "filter-label" }, "Distribution:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => (($setup.filters.distribution) = $event)),
              type: "text",
              class: "filter-input",
              placeholder: "e.g., Allgemein",
              onChange: _cache[27] || (_cache[27] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
              [_vModelText, $setup.filters.distribution]
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[43] || (_cache[43] = _createElementVNode("span", { class: "filter-label" }, "Category:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => (($setup.filters.category) = $event)),
              type: "text",
              class: "filter-input",
              placeholder: "e.g., Kampf",
              onChange: _cache[29] || (_cache[29] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
              [_vModelText, $setup.filters.category]
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _cache[45] || (_cache[45] = _createElementVNode("span", { class: "filter-label" }, "Has Image:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => (($setup.filters.has_image) = $event)),
              class: "filter-select",
              onChange: _cache[31] || (_cache[31] = (...args) => ($setup.onSelectChange && $setup.onSelectChange(...args)))
            }, [...(_cache[44] || (_cache[44] = [
              _createElementVNode("option", { value: "" }, " Any ", -1 /* CACHED */),
              _createElementVNode("option", { value: "1" }, " Yes ", -1 /* CACHED */),
              _createElementVNode("option", { value: "0" }, " No ", -1 /* CACHED */)
            ]))], 544 /* NEED_HYDRATION, NEED_PATCH */), [
              [_vModelSelect, $setup.filters.has_image]
            ])
          ])
        ])
      ], 2 /* CLASS */)
    ], 32 /* NEED_HYDRATION */),
    ($props.savedSearches.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("span", _hoisted_38, _toDisplayString($setup.label("saved", "Saved")) + ":", 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.savedSearches, (search) => {
            return (_openBlock(), _createElementBlock("a", {
              key: search.url,
              href: search.url,
              class: "saved-search-link"
            }, _toDisplayString(search.name), 9 /* TEXT, PROPS */, _hoisted_39))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.showSaveSearch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("form", {
            class: "inline-form",
            onSubmit: _cache[34] || (_cache[34] = (...args) => ($setup.saveSearch && $setup.saveSearch(...args)))
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => (($setup.saveName) = $event)),
              type: "text",
              class: "filter-input small",
              placeholder: $setup.label('saveAs', 'Save as...'),
              required: ""
            }, null, 8 /* PROPS */, _hoisted_41), [
              [_vModelText, $setup.saveName]
            ]),
            _createElementVNode("button", _hoisted_42, " 💾 " + _toDisplayString($setup.label("save", "Save")), 1 /* TEXT */)
          ], 32 /* NEED_HYDRATION */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}